import React, { useState, useEffect } from "react";
import { useIsReadOnlyManager } from "@/shared/readOnlyManager";
import { Table } from "reactstrap";
import { useTable, usePagination } from 'react-table'
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PencilIcon from "mdi-react/PencilIcon";
import TrashIcon from "mdi-react/TrashCanIcon";
import { useTranslation } from "react-i18next";
import { USER_ADDRESS_COLUMNS } from "./columns";
import AddressModal from "./AddressModal";
import {getUserAddress} from "@/services/user/getUser";
import axios from 'axios'
import { sendFlashMessage } from '@/redux/actions/flashActions'
import {flashDispatch, flashMessage } from '@/shared/helpers'
import ApiErrorMessage from "@/shared/components/flash/ApiErrorMessage"
import ReactTablePagination from "@/shared/components/table/components/ReactTablePagination";
const PAGE_SIZE =10;
const ParticipantAddress = ({ participant, auth, program, organization, setRefreshUsers }) => {
  const readOnly = useIsReadOnlyManager();
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [mode, setMode] = useState("add");
  const [count, setCount] = useState(0);
  const dispatch = flashDispatch();
  const [selectedAddress, setSelectedAddress] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (participant?.addresses) {
      setAddresses(participant.addresses);
      setLoading(false);
    }
  }, [participant]);
 
  const handleSave = (data) => {
    const user_id = participant?.id;
    if(user_id !==false) { 
        axios
        .put(`/users/${user_id}/addresses/${selectedAddress?.id}`, data)
        .then((res) => {
            if (res.status === 200) {
            dispatch(
                flashMessage(
                "Address Updated successfully!"
                )
            );
            //toggle();
            setLoading(false);
            setRefreshUsers(true);
            }
        })
        .catch((error) => {
            // return false;
            if (error?.response?.data) {
            dispatch(
                sendFlashMessage(
                <ApiErrorMessage errors={error.response.data} />,
                "alert-danger"
                )
            );
            setLoading(false);
            }
        });
    }
  };
  const onDeleteAddress = (e, address_id) => {
    const user_id = participant?.id;
    if(user_id !==false && user_id !=='undefined' && address_id) {  
        axios
        .delete(`/users/${user_id}/addresses/${address_id}`)
        .then((res) => {
            if (res.status === 200) {
            dispatch(
                flashMessage(
                "Address Deleted successfully!"
                )
            );
            //toggle();
            setLoading(false);
            setRefreshUsers(true);
            }
        })
        .catch((error) => {
            // return false;
            if (error?.response?.data) {
            dispatch(
                sendFlashMessage(
                <ApiErrorMessage errors={error.response.data} />,
                "alert-danger"
                )
            );
            setLoading(false);
            }
        });
    }
  };
  const onClickAction = (name, address={}) => {
    setMode(name);
    if(name == 'edit') {
        setSelectedAddress(address);
    }
    setModalOpen(true);
  };
  const RenderActions = ({ row }) => {
      return (
        <span>
          <Link to={{}} onClick={ () =>{
                onClickAction("edit", row.original)
                }
              }>
            <PencilIcon style={{ marginRight: "0.5rem" }} />
            Edit
          </Link>
          <span style={{ width: "2.5rem", display: "inline-block" }}></span>
          <Link
            to={{}}
            className="delete-column"
            onClick={(e) => {
              if (window.confirm("Are you sure to delete this Address?")) {
                onDeleteAddress(e, row.original.id);
              }
            }}
          >
            <TrashIcon style={{ marginRight: "0.5rem" }} />
            Delete
          </Link>
        </span>
      );
    };
  
    let final_columns = [
      ...USER_ADDRESS_COLUMNS,
      ...(readOnly ? [] : [
        {
            Header: "Action",
            accessor: "action",
            Footer: "Action",
            minWidth: 250,
            width: 250,
            maxWidth: 250,
          Cell: ({ row }) => <RenderActions row={row} />,
        },
      ]),
    ];
  const columns = React.useMemo(() => final_columns, []);
   const tableInstance = useTable({
          columns,
          data: addresses,
          initialState: {
              pageIndex: 0,
              pageSize: 10,
          },
          manualPagination: true,
          pageCount: Math.ceil(count / PAGE_SIZE),
          autoResetSortBy: false,
          autoResetExpanded: false,
          autoResetPage: false,
      }, usePagination);
  const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
        page,
        pageCount,
        pageOptions,
        gotoPage,
        previousPage,
        canPreviousPage,
        nextPage,
        canNextPage,
        setPageSize,
        selectedFlatRows,
        state: { pageIndex, pageSize },
      } = tableInstance;

    useEffect(() => {
    (async () => {
        if (participant?.id) {
            getUserAddress(participant.id, pageIndex, 10)
            .then(data => {
                data.results.map(row => row.amount)
                setAddresses(data.results);
                setCount(data.count);
            })
            .catch(error => {
                console.log(error.response);
            })
        }
    })();
  }, [pageIndex, participant, setRefreshUsers]);

  if (loading) {
    return <p>{t("loading")}</p>;
  }

  return (
    <>
      <Table striped bordered size="md" className="table--stack-mobile" {...getTableProps()}>
        <thead>
          <tr>
            <td colSpan={columns.length} className="title">
              <strong>User Addresses</strong>
            </td>
          </tr>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}
                style={{
                width: column.width,
                minWidth: column.minWidth,
                maxWidth: column.maxWidth,
                }}
                >{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td
                    {...cell.getCellProps()}
                    data-label={typeof cell.column.Header === "string" ? cell.column.Header : ""}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </Table>
      <div className="my-3 status">
        {rows.length > 0 && (
        <>
            <ReactTablePagination
                page={page}
                gotoPage={gotoPage}
                previousPage={previousPage}
                nextPage={nextPage}
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                pageOptions={pageOptions}
                pageSize={pageSize}
                pageIndex={pageIndex}
                pageCount={pageCount}
                setPageSize={setPageSize}
                manualPageSize={[]}
                dataLength={count}
            />
        </>
        )}
      </div>
      <AddressModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        mode={mode}
        onSave={handleSave}
        address={selectedAddress}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    program: state.program,
    organization: state.organization,
  };
};

export default connect(mapStateToProps)(ParticipantAddress);
